import EmailIcon from "@mui/icons-material/Email";
import ListEmailGroups from "./List";
import { EMAIL_GROUPS, NotificationServicePath } from "utils/constants";
import EditEmailGroups from "./Edit";
import CreateEmailGroups from "./Create";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  icon: <EmailIcon />,
  name: NotificationServicePath + EMAIL_GROUPS,
  title: "Имейл групи",
  list: <ListEmailGroups />,
  edit: <EditEmailGroups />,
  create: <CreateEmailGroups />,
  createPermission: permissions.canManageEmailGroups,
  permission: permissions.canPreviewEmailGroups,
};
